import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Tooltip } from 'antd';
import { UsedChannel } from '../../../../../types/account_configurations';

interface ConfigurationUsedChannelsProps {
  channels: UsedChannel[] | null;
}

const ConfigurationUsedChannels: React.FC<ConfigurationUsedChannelsProps> = ({ channels }) => {
  const { t } = useTranslation();

  if (!channels || channels.length === 0) {
    return <span />;
  }

  if (channels.length === 1) {
    return (
      <Tag color="blue">
        {channels[0].channel_name} ({t('configurations:channelPlan')}: {channels[0].plan_name})
      </Tag>
    );
  }

  return (
    <Tooltip
      title={
        <div>
          {channels.map(channel => (
            <div key={channel.channel_id}>
              {t('configurations:channel')}: {channel.channel_name} (
              {t('configurations:channelPlan')}: {channel.plan_name})
            </div>
          ))}
        </div>
      }
    >
      <Tag color="blue">
        {channels.length} {t('configurations:channels')}
      </Tag>
    </Tooltip>
  );
};

export default ConfigurationUsedChannels;
